import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthenticationService } from '@app/shared/services';
import { ConfirmationDialogComponent } from '@app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { DataStorageService } from '@app/shared/services/data-storage.service';
import esJson from '../../../assets/i18n/es.json';
import enJson from '../../../assets/i18n/en.json';

@Component({
  selector: 'app-bank-transfers-dialog',
  templateUrl: './bank-transfers-dialog.component.html',
  styleUrls: ['./bank-transfers-dialog.component.scss'],
  standalone: false
})
export class BankTransfersDialogComponent {
  langJson = (localStorage.getItem('lang') === 'es') ? esJson : enJson;
  transfers: any[] = [];
  eventId: string;
  showAlert = false;
  alertMessage = '';
  alertType: 'success' | 'error' | 'info' | 'warn' = 'info';
  confirmingId: string | null = null;

  constructor(
    protected dialogRef: MatDialogRef<BankTransfersDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { transfers: any[]; eventId: string },
    private dialog: MatDialog,
    private authService: AuthenticationService,
    private dataStorageService: DataStorageService
  ) {
    this.transfers = (data?.transfers || []).slice();
    this.eventId = data?.eventId;
  }

  onClose(): void {
    this.dialogRef.close();
  }

  getTicketNames(transfer: any): string {
    const tickets = transfer?.tickets || [];
    if (!tickets.length) {
      return '-';
    }
    const names = [...new Set(tickets.map((t: any) => t.ticketName || t.ticketType?.name || '-'))];
    return names.join(', ');
  }

  getTicketsCount(transfer: any): number {
    return transfer?.tickets?.length || 0;
  }

  confirmPayment(transfer: any): void {
    const paymentAttemptId = transfer?.paymentAttempt?.id;
    if (!paymentAttemptId) {
      this.alertMessage = this.langJson.events.bankTransferConfirmError;
      this.alertType = 'error';
      this.showAlert = true;
      return;
    }

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: this.langJson.events.bankTransferConfirmMessage,
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }

      this.confirmingId = paymentAttemptId;
      this.authService.setLoader(true);
      this.dataStorageService.confirmBankTransfer(this.eventId, paymentAttemptId).subscribe(
        () => {
          this.transfers = this.transfers.filter(
            t => t?.paymentAttempt?.id !== paymentAttemptId
          );
          this.confirmingId = null;
          this.authService.setLoader(false);
          this.alertMessage = this.langJson.events.bankTransferConfirmSuccess;
          this.alertType = 'success';
          this.showAlert = true;
        },
        err => {
          console.error(err);
          this.confirmingId = null;
          this.authService.setLoader(false);
          this.alertMessage = this.langJson.events.bankTransferConfirmError +
            (err?.error ? ': ' + (typeof err.error === 'string' ? err.error : (err.error.message || '')) : '');
          this.alertType = 'error';
          this.showAlert = true;
        }
      );
    });
  }
}
